import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4122c2b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Bank name:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "BSB:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Account Number:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "card-body ma-3" }
const _hoisted_8 = {
  key: 0,
  class: "sub-heading"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "linked-question data-row"
}
const _hoisted_11 = { class: "linked-question-title fieldname" }
const _hoisted_12 = {
  key: 0,
  class: "linked-question-textarea fielddata"
}
const _hoisted_13 = {
  key: 1,
  class: "linked-question-wording fielddata"
}
const _hoisted_14 = { class: "data-row mb-2" }
const _hoisted_15 = { class: "fieldname" }
const _hoisted_16 = { class: "fielddata" }
const _hoisted_17 = {
  key: 0,
  class: "input-box",
  style: {"position":"relative"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dollar-sign" }, "$", -1))
const _hoisted_19 = {
  key: 1,
  class: "input-box",
  style: {"position":"relative"}
}
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  key: 2,
  class: "data-row"
}
const _hoisted_22 = { class: "fieldname" }
const _hoisted_23 = { class: "fielddata" }
const _hoisted_24 = {
  class: "input-box",
  style: {"position":"relative"}
}
const _hoisted_25 = {
  class: "amount",
  style: {"width":"100%","padding-right":"1rem","height":"50px","background-color":"#ccc","line-height":"50px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dollar-sign" }, "$", -1))
const _hoisted_27 = {
  key: 3,
  class: "data-row"
}
const _hoisted_28 = {
  key: 0,
  class: "linked-question data-row"
}
const _hoisted_29 = { class: "linked-question-title fieldname" }
const _hoisted_30 = {
  key: 0,
  class: "linked-question-textarea fielddata"
}
const _hoisted_31 = {
  key: 1,
  class: "linked-question-wording fielddata"
}
const _hoisted_32 = { class: "fieldname" }
const _hoisted_33 = { class: "fielddata" }
const _hoisted_34 = {
  key: 4,
  class: "data-row"
}
const _hoisted_35 = { class: "fieldname" }
const _hoisted_36 = { class: "fielddata" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = {
  key: 5,
  class: "data-row"
}
const _hoisted_39 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_RadioButtonHorizontal = _resolveComponent("RadioButtonHorizontal")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")
  const _component_AddBankModal = _resolveComponent("AddBankModal")

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["bank-card", _ctx.validFormEachBank() ? 'answered' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          _hoisted_2,
          _createElementVNode("td", null, _toDisplayString(_ctx.bank.bankName), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("td", null, _toDisplayString(_ctx.bank.bsbno), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, _toDisplayString(_ctx.bank.accountNo), 1)
        ])
      ]),
      (_ctx.formType !== 'EER')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-icon btn-secondary sml",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.editBankAccount()))
          }, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bank.atcsSubQuestions, (q, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (q.atcsQuestionTypeId==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(q.wording), 1))
            : _createCommentVNode("", true),
          (q.atcsQuestionTypeId==5 || q.atcsQuestionTypeId==2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (q.linkedSubQuestion)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createTextVNode(_toDisplayString(_ctx.newWording(q.linkedSubQuestion?.wording)) + " ", 1),
                        _createVNode(_component_Popover, {
                          popover: _ctx.popoverObj(q.linkedSubQuestion?.wording)
                        }, null, 8, ["popover"])
                      ]),
                      (q.linkedSubQuestion?.atcsQuestionTypeId==23)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.getResponse(q.linkedSubQuestion)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.getResponse(q.linkedSubQuestion)), 1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.newWording(q.wording)) + " ", 1),
                    _createVNode(_component_Popover, {
                      popover: _ctx.popoverObj(q.wording)
                    }, null, 8, ["popover"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (q.atcsQuestionTypeId==5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_CurrencyInput, {
                            class: "amount pr-3",
                            modelValue: q.responses[0].answerCurrency,
                            "onUpdate:modelValue": $event => ((q.responses[0].answerCurrency) = $event),
                            onKeyup: _cache[1] || (_cache[1] = $event => (_ctx.validFormBank())),
                            options: { currency: 'USD', currencyDisplay: 'hidden', precision: 2, valueRange:{ min: -999999999999, max: 999999999999} }
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _hoisted_18
                        ]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            class: "comments",
                            "onUpdate:modelValue": $event => ((q.responses[0].answerTxt) = $event),
                            onKeyup: _cache[2] || (_cache[2] = $event => (_ctx.validFormBank()))
                          }, null, 40, _hoisted_20), [
                            [_vModelText, q.responses[0].answerTxt]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (q.atcsQuestionTypeId==21)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.newWording(q.wording)) + " ", 1),
                  _createVNode(_component_Popover, {
                    popover: _ctx.popoverObj(q.wording)
                  }, null, 8, ["popover"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.calculateValue(q.developerKey)), 1),
                    _hoisted_26
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (q.atcsQuestionTypeId==3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (q.linkedSubQuestion)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.newWording(q.linkedSubQuestion?.wording)) + " ", 1),
                        _createVNode(_component_Popover, {
                          popover: _ctx.popoverObj(q.linkedSubQuestion?.wording)
                        }, null, 8, ["popover"])
                      ]),
                      (q.linkedSubQuestion?.atcsQuestionTypeId==23)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.getResponse(q.linkedSubQuestion)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.getResponse(q.linkedSubQuestion)), 1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.newWording(q.wording)) + " ", 1),
                  _createVNode(_component_Popover, {
                    popover: _ctx.popoverObj(q.wording)
                  }, null, 8, ["popover"])
                ]),
                _createElementVNode("span", _hoisted_33, [
                  _createVNode(_component_CurrencyInput, {
                    class: "amount pr-3",
                    modelValue: q.responses[0].answerNumber,
                    "onUpdate:modelValue": $event => ((q.responses[0].answerNumber) = $event),
                    onKeyup: _cache[3] || (_cache[3] = $event => (_ctx.validFormBank())),
                    options: { currency: 'USD', currencyDisplay: 'hidden', valueRange:{ min: -999999999, max: 999999999} }
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (q.atcsQuestionTypeId==23)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_ctx.newWording(q.wording)) + " ", 1),
                  _createVNode(_component_Popover, {
                    popover: _ctx.popoverObj(q.wording)
                  }, null, 8, ["popover"])
                ]),
                _createElementVNode("span", _hoisted_36, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": $event => ((q.responses[0].answerTxt) = $event),
                    maxlength: 5000,
                    onKeyup: _cache[4] || (_cache[4] = $event => (_ctx.validFormBank())),
                    style: {"border":"1px solid #aaa","resize":"vertical","width":"100%","height":"150px"}
                  }, "\n            ", 40, _hoisted_37), [
                    [_vModelText, q.responses[0].answerTxt]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["footnote", [ q.responses[0].answerTxt?.length === 5000 ? 'full' : '']])
                  }, _toDisplayString(q.responses[0].answerTxt?.length || 0) + "/5000 characters ", 3)
                ])
              ]))
            : _createCommentVNode("", true),
          (q.atcsQuestionTypeId==10)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_RadioButtonHorizontal, {
                  class: "one-lineOptions",
                  question: _ctx.bank.atcsSubQuestions[i],
                  "onUpdate:question": $event => ((_ctx.bank.atcsSubQuestions[i]) = $event),
                  allQuestions: _ctx.bank.atcsSubQuestions,
                  "onUpdate:allQuestions": _cache[5] || (_cache[5] = $event => ((_ctx.bank.atcsSubQuestions) = $event)),
                  onValidForm: _cache[6] || (_cache[6] = $event => (_ctx.validFormBank()))
                }, null, 8, ["question", "onUpdate:question", "allQuestions"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    (_ctx.formType !== 'EER')
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("button", {
            class: "btn btn-secondary sml ma-3",
            onClick: _cache[7] || (_cache[7] = $event => (_ctx.removeBankAccount()))
          }, "Remove")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmRemoveBankDialogue",
      modalOpened: true
    }, null, 512),
    (_ctx.showNewBankModal)
      ? (_openBlock(), _createBlock(_component_AddBankModal, {
          key: 1,
          onClose: _cache[8] || (_cache[8] = $event => (_ctx.showNewBankModal = false)),
          selectedBank: _ctx.selectedBank,
          "onUpdate:selectedBank": _cache[9] || (_cache[9] = $event => ((_ctx.selectedBank) = $event))
        }, null, 8, ["selectedBank"]))
      : _createCommentVNode("", true)
  ], 2))
}